const handleFilter = () =>{
    if(!document.querySelector('.suizidpraevention-locations-controls')) return;
    // radio event listener
    const allRadios = document.querySelectorAll('.csp-data-radio');
    const allHelp = document.querySelectorAll('.csp-data-checkbox-type-help');
    const allOffers = document.querySelectorAll('.csp-data-checkbox-offer');
    const peerFilterHolder = document.querySelector('[data-active-peer-group]');
    const activeTypeHelpHolder = document.querySelector('[data-active-type-help]');
    const activeTypeOfferHolder = document.querySelector('[data-active-offer]');
    if(allRadios){
        allRadios.forEach(r =>{
            r.addEventListener('change', ev =>{

                if(ev.target.checked){
                    allRadios.forEach(radio =>{
                        if(radio !== ev.target){
                            radio.checked = false;
                        }
                    })
                    if(ev.target.id !== 'csp-location-reset-id'){
                        peerFilterHolder.setAttribute('data-active-peer-group', ev.target.id);
                    }
                    if(ev.target.id === 'csp-location-reset-id'){
                        peerFilterHolder.setAttribute('data-active-peer-group', '');
                    }

                }else{
                    r.checked = false;
                }
            })
        });
    }
    if(allHelp){
        allHelp.forEach(help => {

            help.addEventListener('change', ev =>{
                let attributeString = activeTypeHelpHolder.getAttribute('data-active-type-help');
                let attributeStringArray = [];
                if(attributeString !== ''){
                    attributeStringArray = attributeString.split(',');
                }

                if(ev.target.checked){

                    attributeStringArray.push(ev.target.id);
                }
                if(!ev.target.checked){

                    attributeStringArray = removeFromArrayHelper(ev.target.id, attributeStringArray);
                }
                activeTypeHelpHolder.setAttribute('data-active-type-help', attributeStringArray.join(','));
            })
        })
    }

    if(allOffers){
        allOffers.forEach(offer => {

            offer.addEventListener('change', ev =>{
                let attributeString = activeTypeOfferHolder.getAttribute('data-active-offer');
                let attributeStringArray = [];
                if(attributeString !== ''){
                    attributeStringArray = attributeString.split(',');
                }

                if(ev.target.checked){

                    attributeStringArray.push(ev.target.id);
                }
                if(!ev.target.checked){

                    attributeStringArray = removeFromArrayHelper(ev.target.id, attributeStringArray);
                }
                activeTypeOfferHolder.setAttribute('data-active-offer', attributeStringArray.join(','));
            })
        })
    }


    const removeFromArrayHelper = (item, array) => {
        let indexOfItem = array.indexOf(item);
        if(indexOfItem > -1){
            array.splice(indexOfItem, 1);
        }
        return array;
    }
}
export default handleFilter;